// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/extensions/v1/field_options.proto (package quanterix.common.extensions.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "../../../../google/protobuf/descriptor_pb";
import { file_google_protobuf_descriptor } from "../../../../google/protobuf/descriptor_pb";
import type { CustomOptions } from "./custom_options_pb";
import { file_quanterix_common_extensions_v1_custom_options } from "./custom_options_pb";

/**
 * Describes the file quanterix/common/extensions/v1/field_options.proto.
 */
export const file_quanterix_common_extensions_v1_field_options: GenFile = /*@__PURE__*/
  fileDesc("CjJxdWFudGVyaXgvY29tbW9uL2V4dGVuc2lvbnMvdjEvZmllbGRfb3B0aW9ucy5wcm90bxIecXVhbnRlcml4LmNvbW1vbi5leHRlbnNpb25zLnYxOn0KEWZpZWxkX21hcF9vcHRpb25zEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjQhgMgASgLMi0ucXVhbnRlcml4LmNvbW1vbi5leHRlbnNpb25zLnYxLkN1c3RvbU9wdGlvbnNSD2ZpZWxkTWFwT3B0aW9uc4gBAWIGcHJvdG8z", [file_google_protobuf_descriptor, file_quanterix_common_extensions_v1_custom_options]);

/**
 * Custom options for mapping protobuf fields
 *
 * @generated from extension: optional quanterix.common.extensions.v1.CustomOptions field_map_options = 50000;
 */
export const field_map_options: GenExtension<FieldOptions, CustomOptions> = /*@__PURE__*/
  extDesc(file_quanterix_common_extensions_v1_field_options, 0);

